export default function scrollToFirstElementFormWithError() {
  const elementsWithErrors = []
  document.getElementsByTagName('small').forEach(element => {
    if (element.innerText) {
      elementsWithErrors.push(element)
    }
  })
  elementsWithErrors[0].scrollIntoView({ block: 'end', behavior: 'smooth' })
}
